// Module
var code = "<div data-control-type=\"text-control\" class=\"ToolBarPreview\"> <label data-bind=\"attr: { title: Label }\"> <i class=\"fa fa-font\" aria-hidden=\"true\"></i> <!-- ko text: GetControlTypeTranslatedName() --><!-- /ko --> </label> </div>";
// Exports
export default code;